import { t } from "../../../../utils/i18n";
import { formErrors } from "../../../../utils/formErrors";

export const validateAmount = (amount: number, balance, cardType) => {
  const amountToBeSent = cardType === "virtual" ? 5 : 50;

  if (Number(amount) < amountToBeSent) {
    return t("cards.loads.minimum_amount", { amount: amountToBeSent });
  }

  if (Number(amount) > Number(balance)) {
    return t("cards.loads.amount_too_high");
  }

  return "";
};

export const setApiErrors = (errors, validationErrors) => {
  const formattedErrors = formErrors(errors);

  validationErrors.amountError = formattedErrors["amount"];

  return validationErrors;
};
